// @flow

import React, { Component } from "react";
import { get, noop } from "lodash";
import type { RacePanelLink } from "@fdr/types/Race";
import type { TernaryFn, QuadFn } from "@tvg/types/Functional";
import type { UserOptedInPromos } from "@tvg/types/User";
import { Container, TopRaceRunnerList } from "./styled-components";
import RaceInfoPanel from "../../_molecules/RaceInfoPanel";
import RunnerList from "../TopRacesRunnerList";

type Props = {
  race: RacePanelLink,
  onCardClick: TernaryFn<
    RacePanelLink,
    string,
    string | UserOptedInPromos,
    void
  >,
  raceCardUrl: string,
  onRunnerSelection: QuadFn<
    RacePanelLink,
    number,
    string,
    ?SyntheticKeyboardEvent<*>,
    void
  >,
  optedInPromos: UserOptedInPromos,
  isOpeningApp: boolean,
  betsCounter: number,
  showSilks: {
    [key: string]: boolean
  },
  useIsPromoTagShownFlag: boolean,
  isHighlighted: boolean,
  trackTagText: string
};

class TopRace extends Component<Props> {
  static defaultProps = {
    race: {},
    raceCardUrl: "",
    onCardClick: noop,
    onRunnerSelection: noop,
    optedInPromos: {},
    isOpeningApp: false,
    betsCounter: 0,
    showSilks: {},
    useIsPromoTagShownFlag: false,
    isHighlighted: false,
    trackTagText: ""
  };

  renderRunnerList = () => (
    <TopRaceRunnerList data-qa-label="runner-list-table">
      <RunnerList
        isOpeningApp={this.props.isOpeningApp}
        data-qa-label="top-race-runnerList"
        race={this.props.race}
        numColumns={1}
        raceTypeCode={get(this.props, "race.type.code", "T")}
        raceUrl={this.props.raceCardUrl}
        hasTrackMasterInfo={false}
        runners={this.props.race.bettingInterests}
        onRunnerClick={this.props.onCardClick}
        redirectToRaceCard
        hasHover
        showRunnerLineActiveState={false}
        showSilks={this.props.showSilks}
      />
    </TopRaceRunnerList>
  );

  render() {
    return (
      <Container data-qa-label="top-race-container">
        <RaceInfoPanel
          race={this.props.race}
          raceCardUrl={this.props.raceCardUrl}
          onCardClick={this.props.onCardClick}
          optedInPromos={this.props.optedInPromos}
          renderRunnerList={() => this.renderRunnerList()}
          isMTPInline
          forceMTPDescription
          showActiveBets={this.props.betsCounter > 0}
          useIsPromoTagShownFlag={this.props.useIsPromoTagShownFlag}
          isHighlighted={this.props.isHighlighted}
          trackTagText={this.props.trackTagText}
        />
      </Container>
    );
  }
}

export default TopRace;
